<template>
        <confirm-dialog @confirmed="remove">
         <button-delete><i class="fa fa-trash"></i> Ausstattung löschen</button-delete>
         <template slot="question">Soll die Ausstattung <span class=" font-bold">{{ equipment.name }}</span> wirklch gelöscht werden?</template>
         <template slot="header">Ausstattung löschen</template>
          <template slot="confirm">
            <button-delete><template slot="icon"><i class="fa fa-trash"></i></template> Ausstattung löschen</button-delete>
        </template>
        </confirm-dialog>
</template>

<script>
import ButtonDelete from "../UI/ButtonDelete.vue";
import ConfirmDialog from "../UI/ConfirmDialog.vue";

export default {
    name: "EquipmentDelete",
    components: {ConfirmDialog, ButtonDelete},
    props: ['equipment'],

    data: () => ({
        loading: false,
    }),

    methods: {
        remove() {
            this.loading = true;
            this.$http
                .post('/admin/equipment/' + this.equipment.id, {
                    _method: 'delete',
                })
                .then(() => {
                    this.loading = false;
                    this.$root.$emit('alert', this.equipment.name + ' wurde gelöscht.');
                    this.$emit('leaveModal');
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },

        
    },
}
</script>

<style scoped>

</style>
